import { getDataFromStorage, saveDataToStorage } from '@/utilities/dataStorage';

import { useCityStore } from '@/stores/city/useCityStore';

import { defaultCitiesLocations, TEHRAN_CITY_ID } from '@/constants/common';

import { CityItem } from '@/client/services/geo/cities/models';
import Cookies from 'js-cookie';

const getUserCityCookieOptions = () => ({
    path: '/',
    secure: typeof window !== 'undefined' ? window.location.protocol === 'https:' : true,
    sameSite: 'lax' as const
});

export const syncCityCookies = (city: CityItem) => {
    const fallbackLocation = defaultCitiesLocations[city.id] || defaultCitiesLocations[TEHRAN_CITY_ID];
    const lat = typeof city.latitude === 'number' ? city.latitude : fallbackLocation[0];
    const lng = typeof city.longitude === 'number' ? city.longitude : fallbackLocation[1];
    const cookieOptions = getUserCityCookieOptions();

    Cookies.set('user_city_id', String(city.id), cookieOptions);
    Cookies.set('user_location', JSON.stringify({ lat, lng }), cookieOptions);
};

export const useSelectCity = () => {
    const setCityId = useCityStore((state) => state.setCityId);

    const handleSelectCity = (city: CityItem) => {
        saveDataToStorage('userCity', city, 'local');
        syncCityCookies(city);
        setCityId(city.id, [city.latitude as number, city.longitude as number]);
        handleSetIsCitySelectModalOpen(true);
    };

    const handleSetIsCitySelectModalOpen = (value: boolean) => {
        saveDataToStorage('isUserSelectedCity', value, 'local');
    };

    const userCity = JSON.parse(getDataFromStorage('userCity', 'local'));
    const isUserSelectedCity = JSON.parse(getDataFromStorage('isUserSelectedCity', 'local'));

    return { handleSelectCity, userCity, isUserSelectedCity, syncCityCookies };
};
